var map = {
	"./3x3-Basketball.png": "56b8",
	"./Archery.png": "c3d0",
	"./Artistic-Gymnastics.png": "23b6",
	"./Artistic-Swimming.png": "c42f",
	"./Athletics.png": "2049",
	"./Badminton.png": "4cbc",
	"./Baseball.png": "1c83",
	"./Basketball.png": "96fb",
	"./Beach-Volleyball.png": "804a",
	"./Boxing.png": "0315",
	"./Canoe-Slalom.png": "9548",
	"./Canoe-Sprint.png": "4625",
	"./Cycling-BMX-Freestyle.png": "e136",
	"./Cycling-BMX-Racing.png": "bcd0",
	"./Cycling-Mountain-Bike.png": "32a4",
	"./Cycling-Road.png": "2261",
	"./Cycling-Track.png": "f2e8",
	"./Cycling.png": "1253",
	"./Diving.png": "9b15",
	"./Equestrian.png": "cab8",
	"./Fencing.png": "12a1",
	"./Football.png": "537b",
	"./Golf.png": "2ad4",
	"./Handball.png": "0e5f",
	"./Hockey.png": "208c",
	"./Judo.png": "2019",
	"./Karate.png": "2a09",
	"./Marathon-Swimming.png": "7980",
	"./Modern-Pentathlon.png": "1808",
	"./Rhythmic-Gymnastics.png": "e449",
	"./Rowing.png": "501f",
	"./Rugby-Sevens.png": "5a52",
	"./Sailing.png": "4daa",
	"./Shooting.png": "1f65",
	"./Skateboarding.png": "c74b",
	"./Sport-Climbing.png": "7670",
	"./Surfing.png": "0658",
	"./Swimming.png": "3770",
	"./Table-Tennis.png": "2fe2",
	"./Taekwondo.png": "0a1f",
	"./Tennis.png": "ec3d",
	"./Trampoline-Gymnastics.png": "bec9",
	"./Triathlon.png": "1fb3",
	"./Volleyball.png": "7624",
	"./Water-Polo.png": "36b3",
	"./Weightlifting.png": "b313",
	"./Wrestling.png": "c2df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f3e5";